module.exports = __webpack_public_path__ + "img/3_uk.76831ec5.svg";